import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const UpdateView: React.FC = () => {
    const i18n = useSelector((state: any) => state.i18n.i18n);

    useEffect(() => {
        const timer = setTimeout(() => {
            window.location.reload();
        }, 3 * 60 * 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="text-center p-8 max-w-md">
                <div className="mb-8">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto"></div>
                </div>
                
                <h1 className="text-2xl font-bold text-gray-900 mb-4">
                    {i18n.translate({ id: 'updating.title', sourceName: 'Update' })}
                </h1>
                
                <p className="text-gray-600 mb-6">
                    {i18n.translate({ id: 'updating.description', sourceName: 'Update' })}
                </p>
                
                <div className="text-sm text-gray-500">
                    {i18n.translate({ id: 'updating.hint', sourceName: 'Update' })}
                </div>
            </div>
        </div>
    );
};

export default UpdateView; 